import dotProp from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import states from './states';

const page_details = (state = states.page_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PAGE_STATE: {
      return dotProp.set(state, action.path, action.payload);
    }

    case actionTypes.PAGE_CHANGED:
      return {
        ...state,
        current_page: action.payload.current_page,
        current_sider_module: action.payload.current_sider_module,
      };

    case actionTypes.PAGE_LOADING:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          page_loading: true,
          page_loading_text: action.payload ? action.payload : ""
        }
      };

    case actionTypes.PAGE_LOADED:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          page_loading: false,
          page_loading_text: ""
        }
      };

    case actionTypes.UPDATE_AGENT_STATE_LIST: {
      return {
        ...state,
        agent_states: action.payload
      };
    }

    default:
      return state;
  }
}

export default page_details;



// WEBPACK FOOTER //
// ./src/data/redux/page_details/reducers.js